import {
  Alert,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  Stack,
  Typography,
  Box,
} from '@mui/material';
import { FC, useState } from 'react';

import { useUpdateIndustry } from '@features/industry/hooks/useUpdateIndustry';
import { useUpdateStatus } from '@features/profile/hooks/useUpdateStatus';

import { industries } from './constants';

type SetIndustryStepProps = {
  industryId: number;
  handleNext?: () => void;
};

const SetIndustryStep: FC<SetIndustryStepProps> = ({
  handleNext = () => { },
  industryId,
}) => {
  const [alertText, setAlertText] = useState<string>('');

  const { updateStatus } = useUpdateStatus({
    setAlertText,
    onSuccess: handleNext,
  });
  const { updateIndustryMutation, isUpdateIndustryLoading } = useUpdateIndustry({
    setAlertText,
    onSuccess: () => updateStatus({ has_standard_positions: true }),
  });

  return (
    <Box position="relative">
      {isUpdateIndustryLoading && (
        <Box
          position="absolute"
          top={0}
          left={0}
          width="100%"
          height="100%"
          display="flex"
          justifyContent="center"
          alignItems="center"
          bgcolor="rgba(255, 255, 255, 0.7)"
          zIndex={10}
        >
          <CircularProgress />
        </Box>
      )}
      <Stack spacing={2} marginTop={1} sx={{ opacity: isUpdateIndustryLoading ? 0.4 : 1, pointerEvents: isUpdateIndustryLoading ? 'none' : 'auto' }}>
        {alertText && <Alert severity="error">{alertText}</Alert>}
        <Grid container justifyContent="center" gap={3}>
          {industries.map(({ title, Icon, industryId: id }) => (
            <Grid
              key={title}
              item
              xs={4}
              sm={2.1}
              textAlign="center"
              onClick={() => updateIndustryMutation({ industry_id: id })}
              sx={{
                cursor: 'pointer',
              }}
            >
              <Card
                sx={{
                  borderWidth: '1px',
                  borderStyle: 'solid',
                  borderColor: industryId === id ? 'primary.main' : 'transparent',
                  height: '100%',
                  color: industryId === id ? 'primary.main' : 'secondary.main',
                }}
              >
                <CardContent
                  sx={{
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    textAlign: 'center',
                  }}
                >
                  <Icon color="primary" sx={{ fontSize: '34px' }} />
                  <Typography
                    color="inherit"
                    variant="h6"
                    component="h3"
                    mt={1}
                    fontSize={{ xs: '12px', sm: '14px' }}
                  >
                    {title}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Stack>
    </Box>
  );
};

export default SetIndustryStep;
